import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import ViaCep from 'vue-viacep'
import './assets/css/estilo.css'
import instaLib from './plugins/profissionals'
import helpers from './utils/functions'
import googleFunctions from './utils/google'
import VImageInput from 'vuetify-image-input/a-la-carte'
//import VuetifyGoogleAutocomplete from './plugins/google-autocomplete'
//import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'
import VueCardFormat from 'vue-credit-card-validation'
import VuetifyCreditCard from 'vuetify-credit-card'
import VueClipboard from 'vue-clipboard2'
import underscore from 'vue-underscore'
import firebase from 'firebase/app'
import { firebaseDev, firebaseProd } from './plugins/firebase'
import * as GmapVue from 'gmap-vue'
import i18n from './i18n'
import AOS from 'aos'
import Hotjar from 'vue-hotjar'

import 'aos/dist/aos.css'

i18n.locale = 'pt_BR'
Vue.component('VImageInput', VImageInput)

Vue.prototype.$instaLib = instaLib
Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(underscore)
Vue.use(VueCardFormat)
Vue.use(VuetifyCreditCard)

/*Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyD8edNaQcJnDRVj0nA0QQXJ2Df0Av_7fv0", // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  language: "pt-BR" // Optional
});*/

if (process.env.VUE_APP_ENV !== 'staging') {
  Vue.use(Hotjar, {
    id: '2148537',
    isProduction: process.env.NODE_ENV === 'production'
  })
}

/**
 * Package deprecario. Mantendo a estrutura de config para referencia... isso será apagado no futuro

Vue.use(VueAnalytics, {
  id: ['UA-161977312-1', 'AW-655001617/o_CyCIWWoOsBEJGQqrgC'],
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  },
  fields: {
    userId: store.getters.getUserID,
    userLogin: store.getters.getUserLogin,
    userName: store.getters.getPerfil
      ? store.getters.getPerfil.nome
      : 'Usuário sem perfil selecionado'
  },
  ecommerce: {
    enabled: true,
    enhanced: true
  },
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})
*/
Vue.use(
  VueGtag,
  {
    config: { id: 'UA-161977312-1' },
    includes: [
      { id: 'AW-655001617/o_CyCIWWoOsBEJGQqrgC' },
      { id: 'AW-655001617/ULLzCLD_j-YCEJGQqrgC' }
    ],
    enabled: process.env.NODE_ENV === 'production',
    appName: 'Instacares Web Platform',
    pageTrackerScreenviewEnabled: true
  },
  router
)

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyD8edNaQcJnDRVj0nA0QQXJ2Df0Av_7fv0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    language: 'pt-BR'
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

const plugin = {
  install() {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
    Vue.googleFunctions = googleFunctions
    Vue.prototype.$googleFunctions = googleFunctions
  }
}

Vue.use(plugin)
Vue.use(ViaCep)

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdiSvg'
})

Vue.mixin({
  beforeCreate() {
    const utils = this.$options.utils
    if (utils) {
      const keys = Object.keys(utils)
      for (let i = 0; i < keys.length; i++) {
        this[keys[i]] = utils[keys[i]]
      }
    }
  }
})

Vue.mixin({
  updated() {
    this.$nextTick(function() {
      AOS.refreshHard() // This is needed to avoid the un-animate aos effect
    })
  }
})

// Initialize Firebase
let firebaseConfig
if (process.env.VUE_APP_ENV === 'production') firebaseConfig = firebaseProd
else firebaseConfig = firebaseDev
firebase.initializeApp(firebaseConfig)

router.beforeEach((to, from, next) => {
  let id = store.getters.getIntervalID
  let perfilSelected = store.getters.getPerfilID
  // console.log('Before trigger', id, perfilSelected);
  if (id != null) clearInterval(id)
  if (perfilSelected) {
    // console.log('starting time');
    store.dispatch('setMessageTimer')
  }
  next()
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  created() {
    AOS.init()
    this.$store.dispatch('checkUserStatus')
  },
  render: h => h(App)
}).$mount('#app')
